import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

export interface TableColumn {
  id: string;
  name: string;
  visible: boolean;
  required?: boolean; // Some columns like Status might be required
  minWidth?: number;
  maxWidth?: number;
}

@Component({
  selector: 'app-column-manager',
  templateUrl: './column-manager.component.html',
  styleUrls: ['./column-manager.component.scss'],
})
export class ColumnManagerComponent implements OnInit {
  @Input() columns: TableColumn[] = [];
  @Input() onSave: (columns: TableColumn[]) => void;

  workingColumns: TableColumn[] = [];

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {
    // Create a working copy of the columns
    this.workingColumns = this.columns.map((col) => ({ ...col }));
  }

  onDrop(event: CdkDragDrop<TableColumn[]>) {
    moveItemInArray(this.workingColumns, event.previousIndex, event.currentIndex);
  }

  toggleColumn(column: TableColumn) {
    if (!column.required) {
      column.visible = !column.visible;
    }
  }

  resetToDefault() {
    // Reset to default visibility and order
    this.workingColumns = this.getDefaultColumns();
  }

  save() {
    if (this.onSave) {
      this.onSave(this.workingColumns);
    }
    this.modalCtrl.dismiss(this.workingColumns);
  }

  cancel() {
    this.modalCtrl.dismiss();
  }

  private getDefaultColumns(): TableColumn[] {
    return [
      { id: 'status', name: 'Status', visible: true, required: true, minWidth: 84, maxWidth: 84 },
      { id: 'message', name: 'Message', visible: true, required: true, minWidth: 520 },
      { id: 'submitter', name: 'Submitter', visible: true, minWidth: 180 },
      { id: 'customer', name: 'Customer', visible: true, minWidth: 180 },
      { id: 'assignee', name: 'Assignee', visible: true, minWidth: 180 },
      { id: 'ticketType', name: 'Ticket Type', visible: true, minWidth: 180 },
      { id: 'account', name: 'Account', visible: true, minWidth: 180 },
      { id: 'submitted', name: 'Submitted', visible: true, minWidth: 170, maxWidth: 170 },
      { id: 'tags', name: 'Tags', visible: true, minWidth: 250 },
      { id: 'customerTags', name: 'Customer Tags', visible: true, minWidth: 250 },
      { id: 'responseTime', name: 'Response time', visible: false, minWidth: 170, maxWidth: 170 },
      { id: 'resolutionTime', name: 'Resolution time', visible: false, minWidth: 170, maxWidth: 170 },
      { id: 'lastActivityAt', name: 'Last message sent', visible: false, minWidth: 170, maxWidth: 170 },
      { id: 'project', name: 'Project', visible: false, minWidth: 180 },
    ];
  }
}
